(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-article"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy-link]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-copy-link');
    if (!url) return;
    var copyPromise = navigator.clipboard && navigator.clipboard.writeText
      ? navigator.clipboard.writeText(url)
      : Promise.reject();
    copyPromise.then(function () {
      var feedback = document.querySelector('[data-copy-feedback]');
      if (feedback) {
        feedback.style.opacity = '1';
        clearTimeout(window.__copyFeedbackTimeout);
        window.__copyFeedbackTimeout = setTimeout(function () {
          feedback.style.opacity = '0';
        }, 2000);
      }
    }).catch(function () {
      // Fallback for old browsers — select a hidden textarea and execCommand('copy')
      var ta = document.createElement('textarea');
      ta.value = url;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.drop-countdown');
    if (!sections.length) return;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick(section) {
      var target = new Date(section.getAttribute('data-drop-iso')).getTime();
      if (isNaN(target)) return;

      var now = Date.now();
      var diff = Math.max(0, target - now);
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);

      var d = section.querySelector('[data-countdown-days]');
      var h = section.querySelector('[data-countdown-hours]');
      var m = section.querySelector('[data-countdown-minutes]');
      var s = section.querySelector('[data-countdown-seconds]');
      if (d) d.textContent = pad(days);
      if (h) h.textContent = pad(hours);
      if (m) m.textContent = pad(minutes);
      if (s) s.textContent = pad(seconds);
    }

    sections.forEach(function (section) {
      tick(section);
      setInterval(function () { tick(section); }, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setMainImage(src, srcset) {
      var main = document.getElementById('drop-product-main-image');
      if (!main) return;
      if (src) main.setAttribute('src', src);
      if (srcset) main.setAttribute('srcset', srcset);
    }

    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb]');
      if (thumb) {
        e.preventDefault();
        setMainImage(thumb.getAttribute('data-thumb-src'), thumb.getAttribute('data-thumb-srcset'));
        document.querySelectorAll('[data-thumb]').forEach(function (t) {
          t.classList.remove('ring-2', 'ring-brand-red', 'is-active');
        });
        thumb.classList.add('ring-2', 'ring-brand-red', 'is-active');
        return;
      }

      var copyBtn = e.target.closest('[data-copy-link]');
      if (copyBtn) {
        e.preventDefault();
        var url = copyBtn.getAttribute('data-copy-link');
        if (url && navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () {
            var feedback = copyBtn.parentElement && copyBtn.parentElement.querySelector('[data-copy-feedback]');
            if (feedback) {
              feedback.style.opacity = '1';
              clearTimeout(window.__dropProductCopyTimeout);
              window.__dropProductCopyTimeout = setTimeout(function () {
                feedback.style.opacity = '0';
              }, 2000);
            }
          });
        }
      }
    });

    // Sync the "Add to cart" label and the displayed price with the selected variant.
    document.addEventListener('change', function (e) {
      var radio = e.target.closest('input[name="id"]');
      if (!radio) return;
      var available = radio.getAttribute('data-variant-available') === 'true';
      var price = radio.getAttribute('data-variant-price') || '';
      var addLabel = document.querySelector('[data-add-label]');
      var addBtn = addLabel ? addLabel.closest('button') : null;
      if (addLabel) {
        addLabel.textContent = available ? ('Add to cart — ' + price) : 'Sold out';
      }
      if (addBtn) {
        if (available) {
          addBtn.removeAttribute('disabled');
        } else {
          addBtn.setAttribute('disabled', 'disabled');
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["latest-discussions"] && !Shopify.designMode) return;
  try {
    
  class DismissableCard extends HTMLElement {
    connectedCallback() {
      const id = this.dataset.id;
      if (!id) return;
      const key = `futsoccer:dismissed:${id}`;
      if (window.localStorage && window.localStorage.getItem(key)) {
        this.remove();
        return;
      }
      const btn = this.querySelector('[data-dismiss]');
      if (!btn) return;
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        try {
          window.localStorage.setItem(key, '1');
        } catch (e) {
          // localStorage blocked — still dismiss for this session
        }
        this.style.opacity = '0';
        setTimeout(() => this.remove(), 300);
      });
    }
  }
  if (!customElements.get('dismissable-card')) {
    customElements.define('dismissable-card', DismissableCard);
  }

  } catch(e) { console.error(e); }
})();
})();
